/* eslint-disable no-unused-vars */
/* eslint-disable react/style-prop-object */
import OpenNewTab from "../../../../assets/deepDive/openNewTab.svg";
import React, { Suspense, useMemo } from "react";
// import { add } from "../../../../redux/actions/Home";
import { useDispatch, useSelector } from "react-redux";
import LocationProcess from "./LocationProcess/index";
import { Card, Grid, Tooltip } from "antd";
import ErrorBoundary from "../../../../ErrorBoundary";
import { getFrequentConfigData } from "../../../../redux/constants";
import HighCharts from "../../../utils/charts/HighCharts";
import PostCard from "../../../WidgetMaker/PostCard";
import somethingWentWrong from "../../../../assets/No_Data_Found.svg";
import AuthorCard from "../../../WidgetMaker/AuthorCard";
import isEqual from "react-fast-compare";
// import GridChart from "../../../WidgetMaker/GridChart";
import AdvGrid from "../../../WidgetMaker/AdvGrid/AdvGrid";
const HyperLinkCard = ({
  data,
  index,
  isLoading,
  tabs_type,
  deepDive,
  highlightWord,
}) => {
  const config = useSelector((state) => state.apiCall.config);

  // const getColumnData = (type, data) => {
  //   let column;
  //   if (type === "varchar") {
  //     column = [{ name: data, type: "include" }];
  //   } else if (type === "int") {
  //     const a = data.split("-");
  //     column = { from: a[0], to: a[1] };
  //   } else if (type === "datetime") {
  //     column = { from: data + " 00:00", to: data + " 23:59" };
  //   }
  //   return column;
  // };

  const openNewTab = (first, title, second) => {
    // const primaryAttr = tabDetails?.deep_dive?.attribute?.primary;
    // const secondaryAttr = tabDetails?.deep_dive?.attribute?.secondary;
    // const splitAttr = tabDetails?.deep_dive?.attribute?.split;
    // const primaryValue = tabDetails?.deep_dive?.deep_dive?.primary;
    // const secondaryValue = tabDetails?.deep_dive?.deep_dive?.secondary;
    // const splitValue = tabDetails?.deep_dive?.deep_dive?.split;
    // let firstFilterObj = {
    //   attribute: primaryAttr,
    //   type: frequent[primaryAttr]?.datatype,
    //   columns: getColumnData(frequent[primaryAttr]?.datatype, primaryValue),
    // };
    // let secondFilterObj = {
    //   attribute: secondaryAttr,
    //   type: frequent[secondaryAttr]?.datatype,
    //   columns: getColumnData(frequent[secondaryAttr]?.datatype, secondaryValue),
    // };
    // let splitFilterObj = {
    //   attribute: splitAttr,
    //   type: frequent[splitAttr]?.datatype,
    //   columns: getColumnData(frequent[splitAttr]?.datatype, splitValue),
    // };
    // let filter = tabDetails?.filters ? tabDetails?.filters : [];
    // firstFilterObj && filter.push(firstFilterObj);
    // secondFilterObj?.attribute && filter.push(secondFilterObj);
    // splitFilterObj?.attribute && filter.push(splitFilterObj);
    // if (paneValue?.deep_dive?.overall) {
    //   dispatch(
    //     add(
    //       global.panes ? global.panes : panes,
    //       false,
    //       first !== "" ? first : null,
    //       null,
    //       null,
    //       null,
    //       title
    //     )
    //   );
    // } else {
    //   dispatch(
    //     add(
    //       global.panes ? global.panes : panes,
    //       false,
    //       first !== "" ? first : null,
    //       second ? second : null,
    //       filter ? filter : null,
    //       null,
    //       title
    //     )
    //   );
    // }
  };
  const chart__styles = {
    width: "100%",
    height: "450px",
  };

  const gridResponseData = useMemo(() => {
    if (data?.graph_type === "grid") {
      let graphData = data?.data?.[data?.graph_type]
        ? data?.data?.[data?.graph_type]
        : data?.data;
      return graphData;
    }
    return null;
  }, [isLoading?.[index], data]);
  if (isLoading[index] && !data) {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        {data?.graph_name && (
          <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
            {data?.graph_name}
          </div>
        )}
        <ErrorBoundary chart={true}>
          <div
            className="DeepDive__Widget--body d-flex align-items-center"
            style={{
              justifyContent: "space-evenly",
              height: data?.graph_name ? "48rem" : "53rem",
            }}
          >
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "post-card") {
    let firstTen = data?.data;
    let obj = { data: firstTen?.slice(0, 12), page: 1, limit: 12 };
    return (
      <div
        className={`DeepDive__Widget portlet mb-15 p-0 border-radius-4 ${
          tabs_type === "influencers" ? "border border-color" : ""
        }`}
      >
        <div className="portlet__body">
          <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
            {data?.graph_name}
          </div>
          <div
            className="DeepDive__Widget--body bg__gray"
            style={{
              minHeight:
                data?.["filter-pills"]?.length <= 4 &&
                data?.data?.length <= 3 &&
                deepDive
                  ? "70rem"
                  : "",
            }}
          >
            <ErrorBoundary chart={true}>
              <PostCard
                mentionPage={true}
                data={obj?.data}
                pagination={true}
                filterPills={data?.["filter-pills"]}
                deepDive={true}
                totalPageNo={data?.no_of_pages}
                widget_id="4.1"
                chart_type={data?.graph_type}
                highlightWord={highlightWord}
              />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    );
  } else if (data?.graph_type === "author-card") {
    return (
      <AuthorCard
        data={data?.data}
        pagination={false}
        totalPageNo={data?.no_of_pages}
      />
    );
  } else if (data?.graph_type === "wordcloud") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <ErrorBoundary chart={true}>
          <HighCharts
            single={data?.data}
            style={chart__styles}
            xaxis={data["x_axis-attribute"] ? data["x_axis-attribute"] : ""}
            yaxis={data["y-series"] ? data["y-series"] : ""}
            deepDive={true}
            deepDiveTitle={data?.title}
            type={data?.graph_type}
            id={`${data?.graph_type}#${index + 1}`}
          />
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "sunburst") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <ErrorBoundary chart={true}>
          <HighCharts
            single={data.data}
            style={chart__styles}
            xaxis={data["x_axis-attribute"] ? data["x_axis-attribute"] : ""}
            yaxis={data["y-series"] ? data["y-series"] : ""}
            deepDive={true}
            deepDiveTitle={data?.title}
            type={data?.graph_type}
            id={`${data?.graph_type}#${index + 1}`}
          />
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "bar" && !data?.is_stacked) {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <ErrorBoundary chart={true}>
          <HighCharts
            single={data.data}
            style={chart__styles}
            xaxis={data["x_axis-attribute"] ? data["x_axis-attribute"] : ""}
            yaxis={data["y-series"] ? data["y-series"] : ""}
            deepDive={true}
            deepDiveTitle={data?.title}
            type={data?.graph_type}
            id={`${data?.graph_type}#${index + 1}`}
          />
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "bar" && data?.is_stacked === true) {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <ErrorBoundary chart={true}>
          <HighCharts
            single={data.data}
            style={chart__styles}
            xaxis={data.x_label}
            yaxis={data.y_label}
            deepDive={true}
            type="bar"
            stacked={true}
          />
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "heatmap") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header pl-15 pr-15 pt-1 pb-1 border-bottom border-color d-flex justify-content-between align-items-center">
          <div className="portlet__title fontSize-16 font-weight500">
            {data?.title}
          </div>
          <div className="portlet__title fontSize-14">
            <span className="OpenNewTab invisible">
              <img
                src={OpenNewTab}
                alt="open New tab"
                className="cursor-pointer"
                onClick={() => openNewTab(data?.x_attribute, data?.title)}
              />
            </span>
          </div>
        </div>
        <div className="portlet__body p-15">
          {data?.data && (
            <ErrorBoundary chart={true}>
              {/* <HeatChart
                single={data?.data}
                style={chart__styles}
                deepDive={true}
                xaxis={data?.x_label}
                yaxis={data?.y_label}
              /> */}
            </ErrorBoundary>
          )}
        </div>
      </div>
    );
  } else if (data?.graph_type === "pie") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <ErrorBoundary chart={true}>
          <HighCharts
            single={data?.data}
            style={chart__styles}
            xaxis={data["x_axis-attribute"] ? data["x_axis-attribute"] : ""}
            yaxis={data["y-series"] ? data["y-series"] : ""}
            deepDive={true}
            type={data?.graph_type}
            id={`${data?.graph_type}#${index + 1}`}
          />
        </ErrorBoundary>
      </div>
    );
  } else if (data?.graph_type === "line") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header pl-15 pr-15 pt-1 pb-1 border-bottom border-color d-flex justify-content-between align-items-center">
          <div className="portlet__title fontSize-16 font-weight500">
            {data?.title}
          </div>
          <div className="portlet__title fontSize-14">
            {" "}
            <Tooltip placement="bottom" title="Deep dive">
              <span className="OpenNewTab">
                {" "}
                <img
                  src={OpenNewTab}
                  alt="open New tab"
                  className="cursor-pointer"
                  onClick={() =>
                    openNewTab(
                      data?.x_attribute,
                      data?.title,
                      data?.y_attribute
                    )
                  }
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="DeepDive__Widget--body portlet__body p-15">
          <ErrorBoundary chart={true}>
            <HighCharts
              deepDive={true}
              single={data?.data}
              xaxis={data["x_axis-attribute"] ? data["x_axis-attribute"] : ""}
              yaxis={data["y-series"] ? data["y-series"] : ""}
              style={chart__styles}
              type="line"
            />
          </ErrorBoundary>
        </div>
      </div>
    );
  } else if (data?.graph_type === "progressh") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header pl-15 pr-15 pt-1 pb-1 border-bottom border-color d-flex justify-content-between align-items-center">
          <div className="portlet__title fontSize-16 font-weight500">
            {data?.title}
          </div>
          <div className="portlet__title fontSize-14">
            {" "}
            <Tooltip placement="bottom" title="Deep dive">
              <span className="OpenNewTab">
                {" "}
                <img
                  src={OpenNewTab}
                  alt="open New tab"
                  className="cursor-pointer"
                  onClick={() =>
                    openNewTab(
                      data?.x_attribute,
                      data?.title,
                      data?.y_attribute
                    )
                  }
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="DeepDive__Widget--body portlet__body pt-15 pb-15">
          <ErrorBoundary chart={true}>
            <LocationProcess single={data?.data} style="45rem" AI={true} />
          </ErrorBoundary>
        </div>
      </div>
    );
  } else if (data?.graph_type === "grid") {
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
          {data?.graph_name}
        </div>
        <div className="DeepDive__Widget--body portlet__body LocationProfiles--Grid">
          <ErrorBoundary chart={true}>
            <Suspense fallback={""}>
              <AdvGrid
                tableColumns={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.columns
                }
                tree_grid={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.tree_grid
                }
                rowSpanOn={
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.row_span_on
                }
                grand_total={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.grand_total
                }
                dataSource={
                  gridResponseData?.[0]?.dataSource
                    ? gridResponseData?.[0]?.dataSource
                    : gridResponseData?.[0]?.datasource
                }
                colors={gridResponseData && gridResponseData?.[0]?.colors}
                hideColumns={
                  gridResponseData &&
                  gridResponseData?.[0]?.hide_columns?.length > 0 &&
                  gridResponseData?.[0]?.hide_columns
                }
                hideSorting={
                  gridResponseData &&
                  gridResponseData?.[0]?.hide_sorting?.length > 0 &&
                  gridResponseData?.[0]?.hide_sorting
                }
                dateLabels={
                  gridResponseData &&
                  gridResponseData?.[0]?.date_labels?.length > 0 &&
                  gridResponseData?.[0]?.date_labels
                }
                widgetDurationComparisonForChart={
                  gridResponseData && gridResponseData?.[0]?.columns?.length > 0
                    ? gridResponseData?.[0]?.show_previous_duration_comparison
                      ? gridResponseData?.[0]?.show_previous_duration_comparison
                      : false
                    : false
                }
                widgetDurationDataForChart={
                  gridResponseData && gridResponseData?.[0]?.columns?.length > 0
                    ? gridResponseData?.[0]?.show_previous_duration_data
                      ? gridResponseData?.[0]?.show_previous_duration_data
                      : false
                    : false
                }
                // metadata={data}
                PdfDownloadStatus={false}
                noteExist={false}
                insightsExist={false}
                preview={false}
                deepDive={true}
                type="grid"
              />

              {/* <GridChart
                tableColumns={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.columns
                }
                tree_grid={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.tree_grid
                }
                rowSpanOn={
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.row_span_on
                }
                grand_total={
                  gridResponseData &&
                  gridResponseData?.[0]?.columns?.length > 0 &&
                  gridResponseData?.[0]?.grand_total
                }
                dataSource={
                  gridResponseData?.[0]?.dataSource
                    ? gridResponseData?.[0]?.dataSource
                    : gridResponseData?.[0]?.datasource
                }
                colors={gridResponseData && gridResponseData?.[0]?.colors}
                hideColumns={
                  gridResponseData &&
                  gridResponseData?.[0]?.hide_columns?.length > 0 &&
                  gridResponseData?.[0]?.hide_columns
                }
                hideSorting={
                  gridResponseData &&
                  gridResponseData?.[0]?.hide_sorting?.length > 0 &&
                  gridResponseData?.[0]?.hide_sorting
                }
                dateLabels={
                  gridResponseData &&
                  gridResponseData?.[0]?.date_labels?.length > 0 &&
                  gridResponseData?.[0]?.date_labels
                }
                widgetDurationComparisonForChart={
                  gridResponseData && gridResponseData?.[0]?.columns?.length > 0
                    ? gridResponseData?.[0]?.show_previous_duration_comparison
                      ? gridResponseData?.[0]?.show_previous_duration_comparison
                      : false
                    : false
                }
                widgetDurationDataForChart={
                  gridResponseData && gridResponseData?.[0]?.columns?.length > 0
                    ? gridResponseData?.[0]?.show_previous_duration_data
                      ? gridResponseData?.[0]?.show_previous_duration_data
                      : false
                    : false
                }
                // metadata={data}
                PdfDownloadStatus={false}
                noteExist={false}
                insightsExist={false}
                preview={false}
                deepDive={true}
                type="grid"
              /> */}
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    );
  } else
    return (
      <div className="DeepDive__Widget portlet mb-15 p-0 border-radius-4">
        {data?.graph_name && (
          <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
            {data?.graph_name}
          </div>
        )}
        <ErrorBoundary chart={true}>
          <div
            className="DeepDive__Widget--body d-flex align-items-center"
            style={{
              justifyContent: "space-evenly",
              height: data?.graph_name ? "48rem" : "53rem",
            }}
          >
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </ErrorBoundary>
      </div>
      // <div
      //   className="DeepDive__Widget--body d-flex justify-content-center align-items-center"
      //   style={{ height: "45rem" }}
      // >
      //   <div className="text-center">
      //     <img
      //       alt="no data"
      //       src={somethingWentWrong}
      //       style={{ maxWidth: "100%", minWidth: "20rem" }}
      //     />

      //     <p className="mt-15 text_regular-gray">No Data Found</p>
      //   </div>
      // </div>
    );
};
export default React.memo(HyperLinkCard, isEqual);
